import axios from 'axios';
import { toast } from 'react-hot-toast';

// Define API base URL
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Set up Axios instance with base URL and common headers
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Helper function to get auth token
const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Add an interceptor to attach the auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 Unauthorized errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if the error is due to an unauthorized request (401)
    if (error.response && error.response.status === 401) {
      // Skip handling for registration endpoint - let the register page handle it
      const requestUrl = error.config?.url;
      
      if (requestUrl?.includes('/auth/register')) {
        console.log('🔄 API Interceptor: Allowing register page to handle 401 error');
        return Promise.reject(error);
      }
      
      // Clear auth token
      localStorage.removeItem('authToken');
      
      // Check if we're on the subscription page
      const currentPath = window.location.pathname;
      const isSubscriptionPage = currentPath.includes('/subscription');
      
      // Only show toast and redirect if not on subscription page
      if (!isSubscriptionPage) {
        // Show toast notification
        toast.error('Your session has expired. Please log in again.');
        
        // Redirect to login page with returnTo param
        // Use a small timeout to ensure the toast is shown
        setTimeout(() => {
          window.location.href = `/login?session_expired=true&returnTo=${encodeURIComponent(currentPath)}`;
        }, 100);
      } else {
        // On subscription page, just show a toast without redirecting
        toast.error('Authentication error. Please try refreshing the page.');
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient; 